import { ButtonPosition } from '@/common/manager/position/button-position';
import isEmpty from 'lodash/isEmpty';
export const config = {
    value: 'arrayTableMoveUp',
    position: [ButtonPosition.arrayTableOperate],
    action: (config = {}) => {
        // 该函数只在动作编排里执行
        // 非动作编排是个功能组件
        try {
            const { field } = config;
            const { indexes } = field;
            if (isEmpty(indexes))
                return;
            const index = Number(indexes[0]);
            if (index === 0 || isNaN(index))
                return;
            field.parent.moveUp(index);
        }
        catch (e) {
            console.error('moveup failed', e);
        }
    },
};
